
import mobx, { extendObservable, action } from 'mobx';
import axios from 'axios';
import { includes, map } from 'lodash';
import eb from '../utils/EventBus'
import fileDownload from 'react-file-download';
import {properties} from '../environments';

const BLOCK_CHAIN_URL = properties.BLOCKCHAIN_URL;

class DownloadDataStore {

	constructor() {
		extendObservable(this, {
      			loading: true,
      			docs: [],
      			filteredDocs: [],
      			docIds: [],
      			newComment: '',
            newCmtFlag: '',
            searchTerm: '',
      			selectedDoc: {},
      			operation: undefined,
      			username: null,
            orgname: null,
            docid: null,
            selectedShUsersOptions: [],
            selectedShUsers: null,
            selectedRvwUsersOptions: [],
            selectedRvwUsers: null,
            selectedAppUsersOptions: [],
            selectedAppUsers: null,
            shUserIds: [],
            rvwUserIds: [],
            apprUserIds: [],
		});

    eb.on('search-downloaddata', (val) => this.setSearch(val));

	}

	loadAllDocs = () => {
		axios.get('/api/v1/dldoc/docs').then(({ data }) => {
			this.loading = false;
			this.docs = data;
			//console.log(this.docs);
			this.filteredDocs = data;
		});
	}

  loadCurrWkDocs = () => {
    axios.get('/api/v1/dldoc/currwkdocs').then(({ data }) => {
      this.loading = false;
      this.docs = data;
      //console.log(this.docs);
      this.filteredDocs = data;
    });
  }

  loadPrevWkDocs = () => {
    axios.get('/api/v1/dldoc/prevwkdocs').then(({ data }) => {
      this.loading = false;
      this.docs = data;
      //console.log(this.docs);
      this.filteredDocs = data;
    });
  }

  loadCurrMonDocs = () => {
    axios.get('/api/v1/dldoc/currmondocs').then(({ data }) => {
      this.loading = false;
      this.docs = data;
      //console.log(this.docs);
      this.filteredDocs = data;
    });
  }

  loadPrevMonDocs = () => {
    axios.get('/api/v1/dldoc/prevmondocs').then(({ data }) => {
      this.loading = false;
      this.docs = data;
      //console.log(this.docs);
      this.filteredDocs = data;
    });
  }

	loadShUsers = () => {
      //axios.get('/api/v1/userlist/shusers').then(({ data }) => {
        axios.get('/api/v1/userlist/allusers').then(({ data }) => {
        this.selectedShUsersOptions = data.map(user => ({value: user.userid, label: `${user.email}`}));
      });
    }

    setSelectedShUsers = action((users) => {
          this.selectedShUsers = users;
          this.setShUserId(this.selectedShUsers);

    })

    loadRvwUsers = () => {
      //axios.get('/api/v1/userlist/rvwusers').then(({ data }) => {
      axios.get('/api/v1/userlist/allusers').then(({ data }) => {
        this.selectedRvwUsersOptions = data.map(user => ({value: user.userid, label: `${user.email}`}));
      });
    }

    setSelectedRvwUsers = action((users) => {
         this.selectedRvwUsers = users;
         this.setRvwUserId(this.selectedRvwUsers);
    })

    loadAppUsers = () => {
      //axios.get('/api/v1/userlist/appusers').then(({ data }) => {
      axios.get('/api/v1/userlist/allusers').then(({ data }) => {
        this.selectedAppUsersOptions = data.map(user => ({value: user.userid, label: `${user.email}`}));
      });
    }

    setSelectedAppUsers = action((users) => {
        this.selectedAppUsers = users;
        this.setApprUserId(this.selectedAppUsers);
    })


	updDoc = () => {

     if ((this.newComment === null) || (this.newComment ==="") || (this.newComment===undefined))
        {
                  this.newComment=null;
                  this.newCmtFlag='N';
        }
     else {
            this.newCmtFlag='Y';
     }

		axios.post('/api/v1/dldoc/update', {
			docDetail: this.selectedDoc,
			newCom: this.newComment,
      newComFlag: this.newCmtFlag
		})
			.then((response) => {
				this.loadAllDocs();
                this.newComment=null;
				eb.emit('toast', {
					status: 'success',
					text: 'Document updated'
				})
				eb.emit('doc-updated');
			});
	}



	loadDoc = (docId) => {
        this.docid=docId;
		axios.get(`/api/v1/dldoc/${docId}`).then(({ data }) => {
			this.loading = false;
			this.selectedDoc = data;
		});
	}


    setDocId = action((val) => {
		console.log(val)
		this.selectedDoc.docid = val;
	})

	setDocName = action((val) => {
		console.log(val)
		this.selectedDoc.docname = val;
	})

	setDocDescr = action((val) => {
		console.log(val)
		this.selectedDoc.docdescr = val;
	})

    setDocType = action((val) => {
		console.log(val)
		this.selectedDoc.doctype = val;
	})

	setComments = action((val) => {
        console.log(val)
        this.selectedDoc.comments = val;
    })

    setTag = action((val) => {
        console.log(val)
        this.selectedDoc.tag = val;
    })

    setNewComments = action((val) => {
        console.log(val)
        this.newComment = val;
    })

    setShUserId = action((val) => {
  		  this.selectedDoc.shUserIds = val;
 	})


    setRvwUserId = action((val) => {
      this.selectedDoc.rvwUserIds = val;
    })

    setApprUserId = action((val) => {
      this.selectedDoc.apprUserIds = val;
    })


    getOrgEmail = () => {

       axios.get('/api/v1/uldoc/orgemail')
                    .then(({data}) => {
                      this.username=data.updatedby;
                      this.orgname=data.orgname;
            });
    }

     // Get the BC token

	getBlockChainToken = (username, orgName) => {
      return new Promise((resolve, reject) => {
        axios.post(`${BLOCK_CHAIN_URL}/api/v1/auth_user`, {
            username,
            orgName
        })
            .then(function (response) {
                console.log(response);
                resolve(response.data);
            })
            .catch(function (error) {
                console.log(error);
                reject(error);
            });
   	 });

	}

	dwnld= async ( req, res) =>  {


		    let fileId = this.selectedDoc.docid;

		    // Get BC token
			const token = await this.getBlockChainToken(this.username, this.orgname);

            // Set up the input params needed for download from BC in options variable
			const options = {
	            method: 'GET',
	            headers: { 'Authorization': `Bearer ${token.token}`, 'Content-Type': 'application/json' },
	            url: `${BLOCK_CHAIN_URL}/api/v1/download_file/${fileId}`
	        };

	        //console.log(options);

	        // End point call using AJAX
		    axios(options).then((response) => {
		           fileDownload(new Buffer(response.data), this.selectedDoc.docname);
		    }).catch(err => {
		            console.log(err);
		    });

	}

	creDocDtl = () => {
        console.log(' inside cre doc detail ');

            // Create docdtl
            axios.post('/api/v1/uldoc/credocdtl', {
                    doc: this.selectedDoc
                  })
                    .then((response) => {
                      //eb.emit('toast', {
                      //  status: 'success',
                      //  text: 'Document uploaded successfully'
                      //})
                      eb.emit('document-uploaded');
            });


  }

  setSearch = action((val) => {
        this.searchTerm = val;
        this.filteredDocs = this.docs.filter(i => JSON.stringify(i).toLowerCase().indexOf(val.toLowerCase()) > -1);
  })



}

const store = new DownloadDataStore();
export default store;



// WEBPACK FOOTER //
// ./src/store/downloaddata-store.js